export default {
  title: 'Ajouter une carte',
  buttons: {
    save: 'Enregistrer',
  },
  feedback: {
    success: 'Carte enregistrée avec succès',
  },
};
